import pxToRem from "hooks/usePxToRem";

import {Box, Button, Divider} from "@mui/material";

import {DefaultCardStructure} from "components";
import {
  BasicInfo,
  Contacts,
  CustomerInstructionsModal,
  Transactioners,
} from "./components";
import React, {useState} from "react";
import useAlertMessage from "hooks/useAlertMessage";
import {ProcessInstructions} from "./components/CustomerInstructionsModal/CustomerInstructions.types";
import {useFormContext} from "react-hook-form";
import {Process} from "views/ProcessDetails/refactor/types/process.types";

type Props = {
  patchInstructions: (
    instructions: Partial<ProcessInstructions>,
  ) => Promise<Process | undefined>;
  refetchProcess: () => Promise<Process | undefined>;
};

const ProcessInfo = (props: Props) => {
  const [showAlert] = useAlertMessage();
  const {getValues, reset, setValue} = useFormContext();
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const handleCloseModal = () => {
    setModalIsOpen(false);
  };

  const handleSubmitInstructions = async (
    instructions: Partial<ProcessInstructions>,
  ) => {
    try {
      const result = await props.patchInstructions(instructions);

      setValue("customerInstructions", result?.customerInstructions ?? "", {
        shouldDirty: false,
      });
      setValue("agentInstructions", result?.agentInstructions ?? "", {
        shouldDirty: false,
      });
      setValue("operatingInstructions", result?.operatingInstructions ?? "", {
        shouldDirty: false,
      });
      setValue(
        "operatingClientInstructions",
        result?.operatingClientInstructions ?? "",
        {
          shouldDirty: false,
        },
      );
      setValue("financialInstructions", result?.financialInstructions ?? "", {
        shouldDirty: false,
      });
      setValue("observation", result?.observation ?? "", {
        shouldDirty: false,
      });
    } catch (error: any) {
      showAlert(error?.response?.data?.message);
      console.error(error);
    }
  };

  return (
    <DefaultCardStructure
      linkId="generalInfo"
      title="Processo"
      button={
        <Button
          variant="contained"
          onClick={() => setModalIsOpen(true)}
          sx={(theme) => ({fontSize: theme.typography.button3.fontSize})}
        >
          Instruções gerais
        </Button>
      }
      hasDivider
      badgeText={getValues("processStatus.name")}
    >
      <BasicInfo />
      {modalIsOpen && (
        <CustomerInstructionsModal
          onCloseModal={handleCloseModal}
          isOpen={modalIsOpen}
          handleSubmitInstructions={handleSubmitInstructions}
        />
      )}
      <Transactioners />

      <Box pt={pxToRem(24)}>
        <Divider />
      </Box>

      <Contacts refetchProcess={props.refetchProcess} />
    </DefaultCardStructure>
  );
};

export default React.memo(ProcessInfo);
